import { mode } from "@chakra-ui/theme-tools";
import { StyleFunctionProps } from "@chakra-ui/react";

interface ComponentStyleObject {
  [key: string]: any;
}

interface SliderVariant {
  (props: StyleFunctionProps): ComponentStyleObject;
}

interface SliderConfig {
  components: {
    RangeSlider: {
      variants: Record<string, SliderVariant>;
    };
  };
}

export const sliderStyles: SliderConfig = {
  components: {
    RangeSlider: {
      variants: {
        main: (props: StyleFunctionProps) => ({
          thumb: {
            bg: mode("brand.500", "brand.400")(props),
          },
        }),
      },
    },
  },
};
